query SupplierRatings($id: UUID!, $first: Int, $after: Cursor) {
  supplier(id: $id) {
    id
    ratingsByEntityId(
      first: $first
      after: $after
      orderBy: _CREATED_DATE_DESC
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        ratingValue
        ratingComment
        _createdDate
        _createdByUserName
      }
    }
  }
}
